// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 22V2H22V22H2ZM8.5 12L14 16.25V7.75L8.5 12Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chevron-left-rectangle-filled')
export default class ChevronLeftRectangleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chevron-left-rectangle-filled',
    }
  }
}
